import { IBasePagingRes } from 'src/types/common.type';
import { IThongBaoNhanVien, IThongBaoQuery } from 'src/types/ThongBao.type';
import http from 'src/utils/http';

export default class ThongBaoService {
  private url = '/thong-bao';

  public async list(query: IThongBaoQuery) {
    const { data } = await http.get<IBasePagingRes<IThongBaoNhanVien>>(`${this.url}`, { params: query });
    return data;
  }

  public async soChuaXem() {
    const { data } = await http.get<number>(`${this.url}/chua-xem`);
    return data;
  }

  public async docThongBao(id: number) {
    const { data } = await http.put<boolean>(`${this.url}/doc-thong-bao/${id}`);
    return data;
  }
}
